// resume.stats.dto.ts
import { createZodDto } from "nestjs-zod/dto";
import z from "zod";

export const resumeStatsSchema = z.object({
  total: z.number(),
  public: z.number(),
  private: z.number(),
  locked: z.number(),
});

export class ResumeStatsDto extends createZodDto(resumeStatsSchema) {}

export const topResumeByDownloadsSchema = z.array(
  z.object({
    resumeId: z.string(),
    title: z.string(),
    downloads: z.number(),
  }),
);

export class TopResumeByDownloadsDto extends createZodDto(topResumeByDownloadsSchema) {}
